import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Tippopover from "../UI/Tippopover";

const CheckboxList = ({ options, control, validateClicked, tip }) => {
  const {
    activeCheckboxes,
    activeChildrens,
    toggleMainCheckbox,
    toggleSubCheckbox,
    isValid,
  } = control;

  const hasSelected = activeCheckboxes.length !== 0;
  const { t } = useTranslation();

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between">
        <div>
          <label htmlFor="categories" className="form-label">
            {t("generalForm.categoriesLabel")}
          </label>
          &nbsp;
          <button
            data-bs-toggle="modal"
            data-bs-target="#categoriesListModal"
            className="link-button"
            type="button"
          >
            {hasSelected
              ? t("generalForm.categoriesEditLink")
              : t("generalForm.categoriesSelectLink")}
          </button>
        </div>
        {tip && (
          <div className="tooltip-container">
            <button className="tooltip-button" type="button">
              <i className="bi bi-info-circle" />
            </button>
            <Tippopover tip={tip} />
          </div>
        )}
      </div>
      <div className="categories">
        {activeCheckboxes.map((box, i) => {
          const boxChildrens = activeChildrens.filter(
            (child) => child.parentId === box.id
          );
          const isLast = activeCheckboxes.length - 1 === i;

          return (
            <span key={box.id}>
              <span>{box.value.replace("and", "&")}</span>
              {boxChildrens.length !== 0 && (
                <>
                  {" ("}
                  {boxChildrens
                    .map((child) => child.value.replace("and", "&"))
                    .join(", ")}
                  {`)${isLast ? "" : ", "}`}
                </>
              )}
            </span>
          );
        })}
      </div>
      <div className="modal fade" id="categoriesListModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Apple Podcasts Categories
              </h5>
            </div>
            <div className="modal-body">
              <ul className="col-scrollable short category-list">
                {options.map((opt) => (
                  <li key={opt.id}>
                    <input
                      type="checkbox"
                      value={opt.value}
                      id={`checkbox-${opt.id}`}
                      checked={!!activeCheckboxes.find((c) => c.id === opt.id)}
                      onChange={() => {
                        toggleMainCheckbox(opt.id, opt.value);
                      }}
                    />
                    <label className="ms-2">
                      {opt.value.replace("and", "&")}
                    </label>
                    {opt.childrens && opt.childrens.length ? (
                      <ul className="category-list">
                        {opt.childrens.map((child) => (
                          <li key={child.id}>
                            <input
                              type="checkbox"
                              value={child.value}
                              id={`checkbox-${child.id}`}
                              checked={
                                !!activeChildrens.find((c) => c.id === child.id)
                              }
                              onChange={() => {
                                toggleSubCheckbox(
                                  child.id,
                                  opt.id,
                                  child.value,
                                  opt.value
                                );
                              }}
                            />
                            <label className="ms-2">
                              {child.value.replace("and", "&")}
                            </label>
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
      {!isValid && validateClicked && (
        <div className="invalid-feedback">
          {t("generalForm.categoriesError")}
        </div>
      )}
      {!isValid && !validateClicked && activeCheckboxes.length === 0 && (
        <p>&mdash;</p>
      )}
    </div>
  );
};

export default CheckboxList;
